import { useViewportSize } from "@mantine/hooks";
import dayjs               from "dayjs";
import React               from "react";

import Image      from "_components/atoms/image";
import Typography from "_components/atoms/typography";
import useStyles  from "_styles/pages/blogs/post.js";

import ShareComponent from "./shareComponent";
import TagsComponent  from "./tagsComponent";

const Post = ( { post, tags } ) => {
	if ( !post ) return null;
	const { width }      = useViewportSize ();
	let deviceViewTab    = width <= 1250;
	let deviceMobileView = width <= 600;
	const { classes }    = useStyles ( { deviceViewTab, deviceMobileView } );

	const { title, date, categoryName, featuredImage, content, tags: currentPostTags } = post;

	return (
		<div className = { classes.postContainer }>
			<Typography
				className               = { classes.postHeading }
				component               = { "h1" }
				dangerouslySetInnerHTML = { { __html: title } }

			/>

			<div className = { classes.midSectionContainer }>
				<div className = { classes.middleLeftSection }>
					<span className = { classes.postDescription }>
						{ dayjs ( date ).format ( "MMMD" ) }
					</span>

					<div className = { classes.seperator } />

					<span className = { classes.postDescription }>
						{ categoryName }
					</span>
				</div>

				<div className = { classes.middleRightSection }>
					<ShareComponent post = { post } />
				</div>
			</div>

			<div className = { classes.postImageConatiner }>
				<Image
					className = { classes.postImage }
					src       = { featuredImage }
				/>
			</div>

			<div className = { classes.postContentConatiner }>

				<div
					className               = { classes.contentParagraph }
					dangerouslySetInnerHTML = { { __html: content } }
				/>

				<div className = { classes.contentTagsContainer }>
					<TagsComponent
						categoryName         = { categoryName }
						currentPostTags      = { currentPostTags }
						tags                 = { tags }
					/>

					<div className = { classes.shareComponentContainer }>
						<Typography
							className = { classes.shareTitle }
							title     = "Share :"
						/>

						<ShareComponent post = { post } />
					</div>
				</div>
			</div>

		</div>
	);
};

export default Post;

